import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { container } from "tsyringe";
import Button, { EButtonColor, EButtonSize, EButtonVariant } from "components/elements/Button";
import I18n from "components/materials/I18n";
import ModuleConfig from "configs/ModuleConfig";
import ConfigService from "services/projects/ConfigService";
import ProjectService from "services/ProjectService";
import { useProjectTitle } from "components/pages/ProfessionalSpace/contexts/ProjectTitle";

const configService = container.resolve(ConfigService);
const projectService = container.resolve(ProjectService);
const modules = container.resolve(ModuleConfig).get().modules;

type IProps = {
	className?: string;
	subClassName?: string;
	fullwidth?: boolean;
};

export default function ButtonsContainer(props: IProps) {
	const { project } = useProjectTitle();
	const navigate = useNavigate();

	const navigateToProjectPage = useCallback(() => {
		navigate(modules.pages.Project.props.path.replace(":projectId", project.id));
	}, [navigate, project]);

	const archiveProject = useCallback(async () => {
		try {
			await projectService.archive(project.id);
			navigateToProjectPage();
		} catch (error) {
			console.error(error);
		}
	}, [project, navigateToProjectPage]);

	const publishProject = useCallback(async () => {
		try {
			await configService.publish(project.id);
			navigateToProjectPage();
		} catch (error) {
			console.error(error);
		}
	}, [project, navigateToProjectPage]);

	const onSaveAndQuitClick = useCallback(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const redirectPath = urlParams.get("redirectPath");
		if (redirectPath) {
			navigate(redirectPath);
		} else {
			navigate(modules.pages.MyProjects.props.path);
		}
	}, [navigate]);

	return (
		<div className={props.className}>
			{!project.archivedAt && (
				<Button size={EButtonSize.SMALL} variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} fullwidth={props.fullwidth} onClick={archiveProject}>
					{I18n.asset.pages.professional_space.layout.archive}
				</Button>
			)}
			<div className={props.subClassName}>
				{project.publishedAt && (
						<Button size={EButtonSize.SMALL} variant={EButtonVariant.OUTLINED} color={EButtonColor.PRIMARY} fullwidth={props.fullwidth} onClick={onSaveAndQuitClick}>
							{I18n.asset.pages.professional_space.layout.back}
						</Button>
				)}
				{!project.publishedAt && (
					<>
						<Button size={EButtonSize.SMALL} variant={EButtonVariant.OUTLINED} color={EButtonColor.PRIMARY} fullwidth={props.fullwidth} onClick={onSaveAndQuitClick}>
							{I18n.asset.pages.professional_space.layout.save_and_quit}
						</Button>
						<Button size={EButtonSize.SMALL} variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} fullwidth={props.fullwidth} onClick={publishProject}>
							{I18n.asset.pages.professional_space.layout.save_and_publish}
						</Button>
					</>
				)}
			</div>
		</div>
	);
}
